export type KVRotationJSON = {
  pitch: number
  yaw: number
  roll: number
}

export class KVRotation {
  pitch: number
  yaw: number
  roll: number

  constructor(pitch: number, yaw: number, roll: number) {
    this.pitch = pitch
    this.yaw = yaw
    this.roll = roll
  }

  static fromJSON(json: KVRotationJSON): KVRotation {
    const rotation = new KVRotation(json.pitch, json.yaw, json.roll)
    return rotation
  }

  static toJSON(rotation: KVRotation): KVRotationJSON {
    return {
      pitch: rotation.pitch,
      yaw: rotation.yaw,
      roll: rotation.roll,
    }
  }
}
